import { BORDER_RADIUS, COLORS } from "utils/styles";

import { FullWidthContainer } from "components/PageContainer";
import Head from "next/head";
import Nav from "components/Nav/Nav";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  margin-bottom: 5rem;
  margin-right: 14rem;
`;

const ContentWrapper = styled.div`
  color: ${COLORS.DARKEST_GRAY};
`;

const Heading = styled.h1.attrs({ className: "mabry-regular" })`
  font-size: 4rem;
  margin-top: 3em;
  margin-bottom: 1em;
`;

const Subheading = styled.h1.attrs({ className: "mabry-regular" })`
  font-size: 2rem;
  margin-top: 1em;
  margin-bottom: 1em;
`;

const P = styled.p`
  font-size: 1.5rem;
  max-width: 45em;

  & a {
    color: inherit;
    text-decoration: underline;
  }
`;
const UL = styled.ul`
  max-width: 45em;
`;
const LI = styled.li`
  font-size: 1.5rem;
`;

const InPageNav = styled.nav`
  ${BORDER_RADIUS};
  padding: 1rem;
  position: sticky;
  width: 240px;
  top: 5rem;
  margin-right: 3rem;
  background: ${COLORS.LIGHTEST_GRAY};
`;

const InPageNavWrapper = styled.div`
  @media (max-width: 50em) {
    display: none;
  }
`;

const NavTitle = styled.span.attrs({ className: "mabry-regular" })`
  display: block;
  font-size: 1.125rem;
  margin-bottom: 1rem;
`;

const NavItemList = styled.ul`
  & li {
  }

  & a {
    color: inherit;
  }
`;

export async function getStaticProps() {
  return {
    props: {
      baseUrl: process.env.BASE_URL,
    },
  };
}

const MailchimpWrapper = styled.div`
  margin-left: -20px;
`;

export default function Legal(props) {
  const { baseUrl } = props;
  return (
    <FullWidthContainer>
      <Head>
        <title>Narrative Observatory | Legal</title>
        <link rel="icon" href="/favcon2.png" />
        <meta
          property="og:image"
          content={`${baseUrl}/images/open-graph.png`}
        />
        <meta
          property="twitter:image"
          content={`${baseUrl}/images/open-graph.png`}
        />
      </Head>
      <main>
        <Nav />
        <Container>
          <InPageNavWrapper>
            <InPageNav>
              <NavTitle>Legal</NavTitle>
              <NavItemList>
                <li>
                  <a href="#privacy-policy">Privacy Policy</a>
                </li>
                <li>
                  <a href="#terms-of-use">Terms of Use</a>
                </li>
              </NavItemList>
            </InPageNav>
          </InPageNavWrapper>
          <ContentWrapper>
            <Heading>Privacy Policy and Terms of Use</Heading>
            <Subheading id="privacy-policy">Privacy Policy</Subheading>
            <P>By using our Site, you agree to the following Privacy Policy.</P>

            <P>
              Harmony Labs gathers the following: (1) voluntarily submitted
              personal information, such as, first and last names, telephone
              numbers and email addresses; (2) information provided by your
              computer through the use of “cookies.” Cookies are pieces of
              information that a website transfers to an individual’s hard drive
              for record-keeping purposes. Harmony Labs uses cookies for a
              variety of purposes. You have the option to disable the cookies on
              your browser; (3) IP addresses; (4) aggregate information on what
              pages people access or visit; and (5) analytics information such
              as application types and versions, operating system, screen
              specifications, network location, language, and time spent on
              site.
            </P>

            <P>
              We reserve the right to use or disclose any information as needed
              to satisfy any law, regulation or legal request, to protect the
              integrity of the website or the website’s policies or to protect
              against unauthorized use of the website, or to cooperate in any
              law enforcement investigation or an investigation on a matter of
              public safety. We also reserve the right to share information with
              a successor entity in connection with a corporate merger,
              consolidation, sale of assets or other corporate change respecting
              the website.
            </P>

            <P>
              We take all reasonable steps to ensure the security of your
              personal information. In instances that our website contains links
              to other websites, Harmony Labs is not responsible for the privacy
              practices or the content of such websites. Harmony Labs reserves
              the right at any time, at our sole discretion, to change or
              otherwise modify the Privacy Policy without prior notice. If our
              policies change we will post the changes to our website and
              provide you with the ability to opt out of these new uses. If you
              feel that this website is not following its stated information
              policy, you may contact us at info@harmonylabs.org.
            </P>

            <Subheading id="terms-of-use">Terms of Use</Subheading>
            <P>
              By accessing or using the Harmony Labs website you agree to all of
              the items laid out below (collectively, the “Agreement”) and agree
              to be bound by the terms.
            </P>

            <P>
              This website, and all of its contents, are published solely for
              the self-promotional use of Harmony Labs partner organizations,
              prospective partner organizations and employees. Harmony Labs, or
              one of its customers, clients or affiliates, is the owner or
              authorized user of any trademark, registered trademark and/or
              service mark appearing on our site, and is the copyright owner or
              licensee of the content and/or information on the site, unless
              otherwise indicated.
            </P>

            <P>
              Harmony Labs, grants the user a non-exclusive, non-transferable
              license to access and download, display, and print one copy of the
              content displayed on the site for your internal, business use,
              provided that you do not modify the content in any way. We may
              provide links to third-party websites. Harmony Labs, has no
              responsibility for these third-party websites, which are governed
              by their own Terms of Use and Privacy Policies.
            </P>

            <P>
              You may input your contact information into the Website so that
              Harmony Labs may contact you. When you enter your contact
              information or send an email or other communication to Harmony
              Labs, we may retain those communications in order to process your
              inquiries, respond to your requests, and stay in contact with you.
              We do not give or sell this information to any third parties.
            </P>

            <P>
              Harmony Labs reserves the right at any time, at our sole
              discretion, to change or otherwise modify the Agreement without
              prior notice, and your continued access or use of this Website
              signifies your acceptance of the updated or modified Agreement.
            </P>
          </ContentWrapper>
        </Container>
      </main>
    </FullWidthContainer>
  );
}
